import axios from 'axios';

// URL and endpoint constants
// Codeweb
const RESET_URL = '/pwd/reset'; // POST

export default {
  // POST
  reset(params) {
    return axios.post(RESET_URL, {}, { params });
  },
};



// WEBPACK FOOTER //
// ./src/api/v1/pwd.js